import ActionBarItem from '@rio-cloud/rio-uikit/components/actionBarItem/ActionBarItem';
import { getTrackingAttributes } from '@rio-cloud/rio-uikit/googleAnalyticsUtils';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';

import { getLocale } from '#configuration/lang/langSlice.ts';
import { useAppSelector } from '#store/store.ts';
import { mapLocaleToBaseLocale } from '#utils/locale.ts';

import { config } from '../../config.ts';
import { useMissingPocketDriverDataSourceBannerState } from '../resources/MissingPocketDriverDataSourceBannerState.tsx';

export const ServiceInfoComponent = () => {
    const userLocale = useAppSelector(getLocale) ?? 'en';
    const baseLocale = mapLocaleToBaseLocale(userLocale);
    const { isDismissed, missingCount, restore } = useMissingPocketDriverDataSourceBannerState();
    const showMissingConnectionsBadge = isDismissed && missingCount > 0;

    const title = (
        <div>
            <FormattedMessage id={'intl-msg:ordercom-cloud-frontend.appheader.app.title'} />
            <span className={'text-color-gray margin-left-10'}>{config.serviceVersion}</span>
        </div>
    );

    return (
        <ActionBarItem id='serviceInfo'>
            <ActionBarItem.Icon>
                <span className='icon uikit-icon icon-info-sign' />
                {showMissingConnectionsBadge && (
                    <span className='badge badge-warning badge-indicator badge-indicator-pinging'>{missingCount}</span>
                )}
            </ActionBarItem.Icon>
            <ActionBarItem.Popover title={title}>
                <ActionBarItem.List>
                    <ActionBarItem.ListItem iconName='question' hasLink={true}>
                        <Link
                            to={`https://rio.cloud/${baseLocale}/documents/order-communication/how-to/user-manual`}
                            target='_blank'
                            {...getTrackingAttributes({
                                trigger: 'click',
                                category: 'link autoTracking',
                                action: 'link click',
                                label: 'intl-msg:ordercom-cloud-frontend.appheader.userManual',
                            })}
                        >
                            <FormattedMessage id={'intl-msg:ordercom-cloud-frontend.appheader.userManual'} />
                        </Link>
                    </ActionBarItem.ListItem>
                    {showMissingConnectionsBadge && (
                        <ActionBarItem.ListItem
                            iconName='warning-sign'
                            onClick={restore}
                            className='text-color-warning'
                        >
                            <FormattedMessage
                                id='intl-msg:ordercom-cloud-frontend.appheader.missingDataSources'
                                defaultMessage='Missing data sources'
                            />
                        </ActionBarItem.ListItem>
                    )}
                    <ActionBarItem.ListItem iconName='envelope' hasLink={true}>
                        <Link
                            to={`https://rio.cloud/${baseLocale}/contact/form?opener=order-communication`}
                            target='_blank'
                            {...getTrackingAttributes({
                                trigger: 'click',
                                category: 'link autoTracking',
                                action: 'link click',
                                label: 'intl-msg:ordercom-cloud-frontend.appheader.feedback',
                            })}
                        >
                            <FormattedMessage id={'intl-msg:ordercom-cloud-frontend.appheader.feedback'} />
                        </Link>
                    </ActionBarItem.ListItem>
                </ActionBarItem.List>
            </ActionBarItem.Popover>
        </ActionBarItem>
    );
};
